import React from 'react';

import { ISCBText } from 'types/interfaces/sulu/IContentBlocks';

import ButtonLink from '../primitives/ButtonLink';
import Reveal from './Reveal';

const Text = ({
  title,
  article,
  button_text,
  button_link,
  open_in_new_tab,
  has_centered_title,
  has_centered_aligned_button,
  has_orchid_theme,
}: ISCBText) => (
  <>
    {title && (
      <Reveal>
        <h3
          className={`${has_orchid_theme ? 'text-orchid' : ''} ${
            has_centered_title ? 'text-center' : ''
          }`}
        >
          {title}
        </h3>
      </Reveal>
    )}
    <Reveal>
      <div dangerouslySetInnerHTML={{ __html: article }} />
    </Reveal>
    {button_text && button_link && (
      <Reveal>
        <div className='mt-6'>
          <ButtonLink
            label={button_text}
            url={button_link}
            target={open_in_new_tab ? '_blank' : '_self'}
            alignCenter={has_centered_aligned_button}
            orchidTheme={has_orchid_theme}
          />
        </div>
      </Reveal>
    )}
  </>
);

export default Text;
